<template lang="pug">
  div
    top-nav(headerColor="white")
    .placeholder(v-if="loading")
    transition(name="fade")
      .content.programs-overview(v-if='!loading')
        .grid
          .col-4_xs-12.titles
            router-link(:to="{ name: 'programs'}")
              h2.h-l
                | programs
            h1.h-sm.category
              | {{ categoryName }}
          .col-8_xs-12.week
            .grid.no-margin
              .col-8_xs-12(v-if="noEvents")
                h3.h-xl
                  | Sorry!
                p.h-sm
                  | There are no {{ category.toLowerCase() }} events scheduled. Check back soon, or sign up for our newsletter below to get regular updates.
              .col-8_xs-12(v-for="program in data")
                router-link(:to="{name: 'programs-page', params: { category: programCategory(program), id: program.uid }}")
                  h3.h-m
                    | {{ program.title }}
                  h4.h-sm
                    | {{ program.content.date}}
                  p.h-sxx
                    | {{ program.content.start_time }} - {{ program.content.end_time }}
            .index
              p(
                v-for="page in numPages"
                :class="{ active: active(page)}"
                @click="loadPage(page)"
              )
                | {{ page + 1 }}
    bottom-nav(footerColor="white")
</template>

<script>
import DataMixin from '@/mixins/DataMixin'
import ComponentMixin from '@/mixins/ComponentMixin'

export default {
  name: 'program',
  mixins: [DataMixin, ComponentMixin],

  data () {
    return {
      loading: false,
      loadedData: [],
      // url: 'http://localhost:8888/caam_live/api/programs/',
      url: '',
      offset: 0,
      limit: 10,
      currentIndex: 0
    }
  },

  created () {
    // const loc = window.location
    // const rootUrl = loc.protocol + '//' + loc.host
    // this.url = rootUrl + '/api/programs/'
    this.url = 'https://staging.caamuseum.org/api/programs/'
    this.getData()
  },

  methods: {
    getData: function () {
      const query = '?offset=' + this.offset + '&limit=' + this.limit
      const url = this.url + this.rawCategory + query
      this.loading = true
      this.get(url, response => {
        this.loading = false
        this.loadedData = response.data
      })
    },

    loadPage: function (num) {
      this.currentIndex = num
      this.offset = num * this.limit
      this.getData()
      window.scrollTo(0, 0)
    },

    active: function (num) {
      return num === this.currentIndex
    },

    programCategory: function (item) {
      return item.content.category.split(' ').join('-').toLowerCase()
    }
  },

  computed: {
    rawCategory: function () {
      return this.$route.params.category
    },

    data: function () {
      return this.loadedData.programs
    },

    category: function () {
      return this.loadedData.category
    },

    numPages: function () {
      const total = Math.ceil(this.loadedData.total / 10)
      return total <= 1 ? [] : [...Array(total).keys()]
    },

    noEvents: function () {
      return this.loadedData.programs.length === 0
    },

    categoryName: function () {
      let cat = this.category.toLowerCase()
      if (cat === 'kids teens and families') {
        return 'kids, teens and families'
      } else if (cat === 'all-past-events') {
        return 'all past events'
      } else if (cat === 'now') {
        return 'now!'
      } else if (cat === 'concerts performances and screenings') {
        return 'concerts, performances and screenings'
      } else if (cat === "can't stop won't stop") {
        return "can't stop, won't stop"
      } else {
        return cat
      }
    }
  },

  watch: {
    $route: function () {
      this.getData()
    }
  }
}
</script>

<style lang="sass">
  @import '../styles/_mixins'
  @import '../styles/_variables'
  .programs-overview
    .category
      color: #F4783B
      padding: 0 !important
      margin: 0
    .week
      margin-top: 0
      @include respond-to(xs)
        margin-top: 0
      h2, h3, h4, a
        padding: 0
        margin: 0
      h3
        padding-top: 0.4rem
        display: inline
        border-bottom: solid 2px #FFF
      p
        padding-left: 0
        margin: 0
      a
        &:hover h3
          border-bottom: solid 2px #000
      .index
        margin-top: 4rem
        display: flex
        @include respond-to(xs)
          margin-top: 0
        p
          margin-right: 2rem
          cursor: pointer
          &.active
            border-bottom: solid 2px #000
</style>



// WEBPACK FOOTER //
// ProgramsOverview.vue?92bb866a